import { Button, Space, Tooltip } from 'antd'
import { observer } from 'mobx-react-lite'
import { MdOutlineEdit, MdOutlineVisibility } from 'react-icons/md'

import { officeViewer, OFFICE_VIEWER_TEXTS as T } from './OfficeViewerStore'

import type { OfficeFileKind } from './OpenEditSessionTask'

export interface OfficeFileActionsProps {
    /** `edit_session` документа: `/services/client_documents/{uuid}/edit_session` */
    sessionUrl: string
    kind: OfficeFileKind
    /** Ім'я файлу — заголовок шухляди до відповіді бека */
    fileName: string
    /** `_permissions.update` документа: лише тоді «Редагувати» (P-31, P-32) */
    canEdit: boolean
    /** Після закриття редактора — перечитати файли документа (новий PDF, P-37) */
    onClosed?: () => void
}

/**
 * «Переглянути» / «Редагувати» біля файлу документа (`SPEC-012` §7.10,
 * §9.2; легасі — іконки GrView / FiEdit без підпису, `FileInput.jsx:133-139`).
 *
 * Переглянути можна Word і PDF; редагувати — лише Word і лише з правом
 * змінювати власника. Право ще раз перевіряє бек при видачі токена.
 *
 * Шухляду відкриває єдиний `officeViewer` (вона в макеті, `OfficeViewerHost`).
 */
export const OfficeFileActions = observer(({ sessionUrl, kind, fileName, canEdit, onClosed }: OfficeFileActionsProps) => {
    const editable = kind === 'word' && canEdit

    return (
        <Space size={4} className="wl-office-file-actions">
                <Tooltip title={T.view}>
                    <Button
                        size="small"
                        type="text"
                        aria-label={`${T.view}: ${fileName}`}
                        icon={<MdOutlineVisibility />}
                        onClick={() => void officeViewer.open(sessionUrl, kind, 'view', fileName, onClosed)}
                    >
                        {T.view}
                    </Button>
                </Tooltip>
                {editable ? (
                    <Tooltip title={T.edit}>
                        <Button
                            size="small"
                            type="text"
                            aria-label={`${T.edit}: ${fileName}`}
                            icon={<MdOutlineEdit />}
                            onClick={() => void officeViewer.open(sessionUrl, kind, 'edit', fileName, onClosed)}
                        >
                            {T.edit}
                        </Button>
                    </Tooltip>
                ) : null}
        </Space>
    )
})
